'use strict';

var systemImageGrid = require('image-grid-2.0.0');
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var dataMgr = require('./data-mgr');
var favorites = require('./favorites');
var favoritesIconHelper = require('./favorites-icon-helper');

var isScrollingBlocked = false;

var findFavoriteBtn = function($el) {

	return $el.find('.image-grid__favorite-btn');

};

var customTextWrapperMarkupCallback = function(itemData) {
 
	var isFavorite;
	var favoriteIconClass;
	var favoriteTitleText;
	var markup = '';

	if (dataMgr.hasFavoritesEnabled()) {

		isFavorite = favorites.isFavorite(itemData.photoId);
		favoriteIconClass = favoritesIconHelper.getClass(isFavorite);
		favoriteTitleText = favoritesIconHelper.getToolTip(isFavorite);

		markup = '<i class="button button--icon button--primary image-grid__favorite-btn proofing-icon ' + favoriteIconClass + '" title="' + favoriteTitleText + '"></i>';

	}

	if (!appDom.isTouch() && dataMgr.hasEcommerceEnabled()) {

		markup += '<i class="button button--icon button--primary js-load-buy-panel image-grid__add-to-cart-btn proofing-icon proofing-icon--shopping-bag" title="' + window.pbizServer.content.addToCart + '" data-selected-photo-index="' + itemData.index + '" data-save-active-panel="false"></i>';

	}

	return markup;

};

var loadImageGrid = function(imageIndex) {

	// We want to load a new gallery, so first destroy any existing one.
	systemImageGrid.destroy();

	window.scrollTo(0, 0);

	systemImageGrid.init({
		data: dataMgr.getGalleryData(),
		initialBatchSize: imageIndex ? imageIndex + 1 : 0,
		// Request additional images be added to the initial batch size, based on current viewport size, this helps add additional scroll space to get the image to the top of the grid
		initialBatchSizeSurplus: true,
		customTextWrapperMarkupCallback: customTextWrapperMarkupCallback
	});

	if (imageIndex) {

		scrollToImg(imageIndex);

	}

};

var processPage = function() {

	appDom.grid.removeClass('image-grid--favorites');

	if (dataMgr.isGridState()) {

		if (dataMgr.isFavoritesGallery()) {

			appDom.grid.addClass('image-grid--favorites');

		}

		processGallery();

	}

};

var doesGridMarkupExist = function() {

	return appDom.grid.children().length;

};

var preventDefault = function(e) {

	e.preventDefault();

};

var blockScrolling = function() {

	if (!isScrollingBlocked) {

		isScrollingBlocked = true;
		document.body.addEventListener('touchmove', preventDefault, {passive: false});

	}

};

var unblockScrolling = function() {

	if (isScrollingBlocked) {

		isScrollingBlocked = false;
		document.body.removeEventListener('touchmove', preventDefault);
	}

};

var scrollToImg = function(imgIndex) {

	window.scrollTo(0, appDom.appContent.find('[data-image-grid-index="' + imgIndex + '"]').offset().top - appDom.topBar.height());

};

var processGallery = function() {

	var galleryIndex = dataMgr.getGalleryIndex();
	var lastPageData = dataMgr.getLastPageData();

	triggerCustomEvent('image_grid_loading');

	if (lastPageData.type === 'slideshow' && lastPageData.galleryIndex === galleryIndex) {

		// We either just closed the slideshow or hit the back button from a slideshow

		if (doesGridMarkupExist()) {

			unblockScrolling();
			// Scroll to image before revealing page in case we loaded slideshow but never changed images, and to also handle the scenario where the page height has changed due to new item injections, allowing us to scroll the current image closer to the top than we could before, when we got to this image on the slideshow
			scrollToImg(lastPageData.slideshowIndex);

		} else {

			// We're closing a slideshow that was deep linked to, build the grid so we can see the last slideshow image
			loadImageGrid(lastPageData.slideshowIndex);

		}

	} else {

		// We are either entering the app for the first time or loading a new gallery

		loadImageGrid();

	}

	triggerCustomEvent('image_grid_loaded');

	dataMgr.setLastPageData({
		type: 'gallery',
		galleryIndex: galleryIndex
	});

};

var addEventHandlers = function() {

	// No longer blocking scrolling since doing so made it impossible to zoom slideshow images when coming from the grid. If removing scroll blocking causes issues, then another method of blocking will need to be investigated, other than preventing the touchmove event.
	// appDom.document.on('slideshow_opened', function() {

	// 	if (doesGridMarkupExist()) {

	// 		blockScrolling();

	// 	}

	// });

	appDom.document.on('slideshow_image_changed', function(e, data) {

		if (doesGridMarkupExist()) {

			console.log('scrolling the grid to...', data.imageIndex);
			scrollToImg(data.imageIndex);

		}

	});

	appDom.document.on('side_panel_opened', function() {

		// We don't want to block if we're in the slideshow
		if (dataMgr.isGridState()) {

			blockScrolling();

		}

	});

	appDom.document.on('side_panel_closed', function() {

		// We don't want to unblock and resume infinite scroll if we're in the slideshow
		if (dataMgr.isGridState()) {

			unblockScrolling();

		}

	});

	appDom.document.on('favorite_added favorite_removed', function(e, data) {

		console.log('favorite toggled...', e);

		var wasAdded;
		var $item;
		var $icon;

		// Make sure grid markup exists, we could have deep linked directly into the slideshow
		if (doesGridMarkupExist()) {

			wasAdded = e.type === 'favorite_added';
			$item = systemImageGrid.getItemByIndex(data.imageIndex);
			$icon = findFavoriteBtn($item);

			favoritesIconHelper.toggleClass($icon, wasAdded ? true : false);
			favoritesIconHelper.toggleToolTip($icon, wasAdded ? true : false);

		}

	});

	appDom.document.on('favorites_updated_via_login', function() {

		// The user just logged in, update the favorite hearts for the currently
		// displayed grid

		var $items;

		// Make sure grid markup exists, we could have deep linked directly into the slideshow
		if (doesGridMarkupExist()) {

			$items = systemImageGrid.getItems();

			$items.each(function(i) {

				var $item = $items.eq(i);
				var $icon = findFavoriteBtn($item);
				var itemIndex = systemImageGrid.getItemIndex($item);
				var isFavorite = favorites.isFavorite(dataMgr.getImageMeta(itemIndex).photoId);

				favoritesIconHelper.toggleClass($icon, isFavorite);
				favoritesIconHelper.toggleToolTip($icon, isFavorite);

			});

		}

	});

	appDom.document.on('gallery_data_ready', processPage);

	if (!appDom.isTouch()) {

		appDom.grid.on('click', '.image-grid__favorite-btn', function(e) {

			var $this = $(this);
			var index = systemImageGrid.getItemIndex($this);

			e.stopPropagation();

			triggerCustomEvent('image_grid_favorite_btn_clicked', {
				data: {
					photoId: dataMgr.getImageMeta(index).photoId,
					imageIndex: index
				}
			});

		});

	}

	appDom.document.on('click', '.image-grid__item', function(/*e*/) {

		// alert('image grid item clicked!');

		// e.preventDefault();

		var index = systemImageGrid.getItemIndex($(this));

		triggerCustomEvent('image_grid_image_clicked', {
			data: {
				imageIndex: index
			}
		});

	});

	/*appDom.grid.on('click', '.image-grid__add-to-cart-btn', function(e) {

		var index = systemImageGrid.getItemIndex($(this));
		var imageMeta = dataMgr.getImageMeta(index);

		triggerCustomEvent('image_grid_add_to_cart_btn_clicked', {
			data: {
				imageIndex: index,
				photoId: imageMeta.photoId
			}
		});

		e.stopPropagation();

	});*/

};

var init = function() {

	addEventHandlers();

};

module.exports = {

	init: init

};
